module.exports = __webpack_public_path__ + "static/media/keybase.5e342fe8.svg";